// generic map component
(function(){
  function GMap(){
    var map,
        markers = [],
        self = {};

    function clearMarkers(){
      for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }

      markers = [];
    }

    function addMarker(opt){
      var gMarker = new google.maps.Marker(opt);
      gMarker.setMap(map);
      markers.push(gMarker);
      return gMarker;
    }

    function resizeMap(){
      google.maps.event.trigger(map, 'resize');
      return false;
    }

    function setCenter(lat, lng){
      map.setCenter(new google.maps.LatLng(lat, lng));
    }

    function getCenter(){
      return map.center;
    }

    function getMap(){
      return map;
    }

    function setZoom(zoomLevel){
      map.setZoom(zoomLevel);
    }

    function onAddMarker(e, location){
      addMarker({
        position: new google.maps.LatLng(location.lat, location.lng),
        visible: true,
        draggable: false
      });
      return false;
    }

    function onSetCenter(e, center){
      setCenter(center.lat, center.lng);
      return false;
    }

    function init(container){
      if(!container || container.length == 0) { return; }

      map = new google.maps.Map(container[0], {
        zoom: 11,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        center: new google.maps.LatLng(52.49, 13.43)
      });

      container.on('map.add-marker', onAddMarker)
        .on("map.clear-markers", clearMarkers)
        .on("map.set-center", onSetCenter)
        .on("map.resize", resizeMap);

      container.data('map', this);

      return this;
    };

    return {
      init: init,
      addMarker: addMarker,
      resize: resizeMap,
      setCenter: setCenter,
      setZoom: setZoom,
      getCenter : getCenter,
      getMap: getMap
    };
  };

  window.GMap = GMap;

  initMap = function (form) {
    var mapCanvas = form.find('#address-map-canvas'),
        lat = form.find('#lat'),
        lng = form.find('#lng'),
        geocodeFields = form.find('.geocode'),
        countryField = form.find("select.country"),
        gMap, marker,
        geocoder;

    function setLocation(latitude, longitude) {
      lat.val(latitude);
      lng.val(longitude);
    }

    function updateMap(center) {
      marker.setPosition(center);
      marker.setVisible(true);
      gMap.setCenter(center.lat(), center.lng());
      gMap.setZoom(18);
      setLocation(center.lat(), center.lng());
    }

    function gGeocode() {
      var self  = $(this);
      var value = $.trim(self.val());

      if (!value) {
        return false;
      }

      var addressParts = [];
      form.find('.geocode').each(function () {
        var val = $(this).val();
        if(val != "") {
          addressParts.push(val);
        }
      });
      geoCodeAddressParts(addressParts);
    };

    function geoCodeAddressParts(parts) {
      if(parts.length < 1) {
        return false;
      }
      var address = parts.join(" ");
      console.log("Geocoding: " + address);
      geocoder.geocode({address: address}, function (res, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          form.find('#address-map').show();
          gMap.resize();
          updateMap(res[0].geometry.location);
        } else {
          // if we didn't find anything, let's try again with less info - throw
          // away the "smaller" address parts first so that finally at least the
          // country should be used. Also this gives us an excuse to write recursive code ;)
          parts.shift();
          geoCodeAddressParts(parts);
        }
      });
    }

    gMap = GMap().init(mapCanvas);

    geocoder = new google.maps.Geocoder();
    marker = gMap.addMarker({
      position: gMap.getCenter(),
      visible: false,
      draggable: true});

    if (lat.val() && lng.val()) {
      updateMap(new google.maps.LatLng(lat.val(), lng.val()));
    }

    google.maps.event.addListener(marker, 'dragend', function () {
      var location = this.getPosition();
      setLocation(location.lat(), location.lng());
    });

    geocodeFields.change(gGeocode);

    geocodeFields.each(function () {
      var self = $(this),
          timer,
          handler = function () {
            self.trigger('change');
            clearTimeout(timer);
          };

      self.on('keyup', function () {
        if (timer) {
          clearTimeout(timer);
        }

        timer = setTimeout(handler, 1000);
      });

    });

    form.find('#clear-address').click(function () {
      geocodeFields.val('');
      countryField.find("option").first().attr("selected", "selected");
      setLocation('', '');
      form.find('#address-map').hide();
      return false;
    });
  }

}());

(function () {
  $(document)
    .on('ready', function () {
      $('#address-map-canvas').each(function () {
        initMap($(this).closest('form'));
      })
    })
}())
